type AspectRatio =
  { height?: number; width?: null } | { height?: null; width?: number };

export const getImageAspectRatio = ({
  height = 0,
  width = 0,
  aspectRatio = "16/9",
}: {
  aspectRatio?: "16/9" | "1/1" | "4/3" | number;
} & AspectRatio) => {
  const ratio =
    typeof aspectRatio === "number"
      ? aspectRatio
      : aspectRatio
          .split("/")
          .reduce((acc, cur) => (acc ? acc / parseInt(cur) : parseInt(cur)), 0);
  if (height)
    return {
      height,
      width: Math.round(height * ratio),
    };
  if (width)
    return {
      width,
      height: Math.round(width / ratio),
    };

  return {
    height: 0,
    width: 0,
  };
};
